// Dependency-free emoji support: a curated picker grid + :shortcode: auto-convert.
export const EMOJIS = [
  "😀","😁","😂","🤣","😊","😍","😘","😎","🤩","🥳","😉","🙂","🙃","😌","😴","🤔",
  "🤗","🤝","👏","🙌","👍","👎","👊","✊","🤙","🙏","💪","🫶","👀","🎉","🔥","✨",
  "💯","⭐","🌟","💡","🚀","📈","💼","🎯","✅","❤️","🧡","💛","💚","💙","💜","🖤",
  "😅","😇","😭","😢","😤","😳","🥹","😬","🤯","😱","👋","🤞","💥","☕","🍻","🫡",
];

// Common :shortcode: → emoji mappings.
export const SHORTCODES = {
  smile: "😄", grin: "😁", joy: "😂", rofl: "🤣", blush: "😊", heart_eyes: "😍",
  kiss: "😘", sunglasses: "😎", star_struck: "🤩", party: "🥳", tada: "🎉", wink: "😉",
  slight_smile: "🙂", thinking: "🤔", hug: "🤗", handshake: "🤝", clap: "👏",
  raised_hands: "🙌", "+1": "👍", thumbsup: "👍", "-1": "👎", thumbsdown: "👎",
  fist: "👊", pray: "🙏", muscle: "💪", eyes: "👀", fire: "🔥", sparkles: "✨",
  "100": "💯", star: "⭐", bulb: "💡", rocket: "🚀", chart: "📈", briefcase: "💼",
  dart: "🎯", check: "✅", heart: "❤️", orange_heart: "🧡", sob: "😭", cry: "😢",
  scream: "😱", wave: "👋", crossed_fingers: "🤞", boom: "💥", coffee: "☕",
  beers: "🍻", salute: "🫡", ok_hand: "👌", eyes_roll: "🙄", cool: "😎",
};

// Convert any completed :name: token in the text to its emoji.
export function applyShortcodes(text) {
  if (!text || text.indexOf(":") === -1) return text;
  return text.replace(/:([a-z0-9_+-]+):/gi, (m, name) => SHORTCODES[name.toLowerCase()] || m);
}
